import React from 'react';
import {Button, Dialog, DialogContent, createTheme} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import Rocket from '../../assets/images/canceled.png';
import {ThemeProvider} from 'react-jss';
import CloseButton from '../../assets/icons/close-circle.svg';
import {setSessionItem} from 'services/sessionStorage';

const useStyles = makeStyles({
  title: {
    fontFamily: 'iranSansX',
    color: '#1D2129',
    fontSize: 16,
    fontWeight: 600,
    marginBottom: -3,
    textAlign: 'center',
  },
  div: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
  text: {
    fontFamily: 'iranSansX',
    color: '#4E5969',
    fontSize: 14,
    fontWeight: 400,
    textAlign: 'center',
    lineHeight: '20px',
  },
  button: {
    backgroundColor: '#30ACFF',
    color: '#fff',
    borderRadius: '12px',
    marginTop: 10,
    marginBottom: 10,
    fontFamily: 'iranSansX',
    fontSize: '16px',
    fontWeight: 500,
    width: '245px',
    letterSpacing: '0px',
    height: '48px',
    '&:hover': {
      backgroundColor: '#30ACFF',
    },
  },
});

const theme = createTheme();

export default function CanceledSessionModal({canceledModal}) {
  const classes = useStyles();
  const handleHardReload = () => {
    setSessionItem('canceledModal', 'false');
  };
  const hardReload = () => {
    setSessionItem('canceledModal', 'false');
    window.location.href = '/app/advisers?online=true';
  };

  return (
    <ThemeProvider theme={theme}>
      <div>
        <Dialog
          open={canceledModal}
          aria-labelledby="form-dialog-title"
          PaperProps={{
            style: {
              borderRadius: '24px',
              width: 294,
              height: 344,
            },
          }}
        >
          <DialogContent>
            <div className={classes.div}>
              <div style={{position: 'absolute', top: 14, left: 14}}>
                <Button
                  style={{
                    minWidth: '20px',
                    padding: 0,
                    margin: 0,
                  }}
                  onClick={handleHardReload}
                >
                  <img
                    src={CloseButton}
                    style={{
                      width: '20px',
                      height: '20px',
                      display: 'block',
                    }}
                    alt="close"
                  />
                </Button>
              </div>
              <img src={Rocket} style={{width: '143px', height: '146px'}} />
              <h2 className={classes.title}>پزشک/مشاور مدنظرت پاسخگو نبود؟!</h2>
              <p className={classes.text}>
                می‌تونیم پزشک و مشاور دیگری بهت
                <br />
                معرفی کنیم که در دسترسه!
              </p>
              <Button className={classes.button} onClick={hardReload}>
                مشاوران پیشنهادی
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </ThemeProvider>
  );
}
